<template>
  <div>
    <modals-container name="modal1" />
    <v-dialog name="dialog" />
    <div class="admin_title">账号管理</div>
    <!--右侧内容-->
    <div style="padding: 0 10px;">
      <div class="gj_top_class" style="margin-bottom: 10px;">
        <input name="" type="button" class="btn_s_gj" @click="search(filters)"/>
        <input name="" type="text" class="put_gj" placeholder="姓名、手机、邮箱和身份证" @keyup.13="search(filters)" v-model="filters.search" />
        <select name="type" class="selcet_put" v-model="filters.chkFlag" @change="searchByChkFlag(filters.chkFlag)">
          <option value="">全部(审核状态)</option>
          <option value="1">启用</option>
          <option value="0">禁用</option>
        </select>
        <a @click="multiAudit(selected, {title: '批量确认', text: '确认通过吗？', msg: '已确认', state: '1'})"  style="background: none; margin-right: 0; padding-left: 0;"><el-button :disabled="selected.length == '0'" type="danger" size="mini" icon="el-icon-my-enable">批量启用</el-button></a>
      </div>
      <div class="gj_list" style="min-height:720px;">
        <el-table v-if="tableData.data && tableData.data.length > 0"
                  :data="tableData.data" stripe border @selection-change="updateSelected"
                  style="width: 100%">
          <el-table-column
            type="selection"
            width="45">
          </el-table-column>
          <el-table-column
            label="真实姓名" width="120" sortable>
            <template slot-scope="scope">
              <a slot="reference" @click.stop="showInfo(scope.row)" style="text-decoration: underline; color: #606266; cursor: pointer;">
                {{scope.row.name}}
              </a>
            </template>
          </el-table-column>
          <el-table-column prop="mobile" label="手机" width="120"></el-table-column>
          <el-table-column prop="idCard" label="身份证" width="240"></el-table-column>
          <el-table-column prop="accountName" label="账号"></el-table-column>
          <el-table-column prop="createDate" label="注册时间"></el-table-column>
          <el-table-column label="操作" width="90">
            <template slot-scope="scope">
              <!--i class="el-icon-my-admin" @click="setUser(scope.row, '2')" style="cursor: pointer;" v-if="!isOrgAdmin(scope.row)"></i-->
              <a title="启用" class="el-icon-my-enable" @click="chkUser(scope.row, '1')" style="cursor: pointer;" v-if="scope.row.chkFlag == '0'"></a>
              <a title="禁用" class="el-icon-my-disable" @click="chkUser(scope.row, '0')" style="cursor: pointer;" v-if="scope.row.chkFlag == '1'"></a>
              <a title="删除" class="el-icon-delete" @click="muteUser(scope.row, '4')" style="cursor: pointer;"></a>
              <a title="激活邮箱" class="el-icon-message" @click="activateUser(scope.row)" style="cursor: pointer;" v-if="scope.row.isActive == '0'"></a>
              <a title="重置密码" class="el-icon-my-reset" @click="resetUser(scope.row)" style="cursor: pointer;"></a>
            </template>
          </el-table-column>
        </el-table>
        <h5 class="none_ts" v-if="cnt == '0'">
          <img src="@/assets/images/none_data.jpg" alt="">
        </h5>
      </div>
    </div>
    <!--/右侧内容-->
    <div class="zy_list_bottom mtf30">
      <dl>
        <dt v-if="tableData.data.length > 0"><!--<input id="sel_1" onchange="selectAll()" type="checkbox" value="1" style="opacity: 1;"/> 全选 <input name="" type="button" value="批量上架" class="btn_zy_bottom" /> <input name="" type="button" value="批量下架"  class="btn_zy_bottom"/> <input name="" type="button" value="删除所选"  class="btn_zy_bottom" />-->共{{cnt}}条记录</dt>
        <dd v-if="tableData.data.length >0">
          <paginate v-if="pages > 0" :click-handler="clickCallback" :page-count=pages
                    :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                    :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                    :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                    :first-last-button=$global.paginationOptions.first_last_button
                    :active-class=$global.paginationOptions.active_class
                    :disabled-class=$global.paginationOptions.disabled_class
                    :first-button-text=$global.paginationOptions.first_button_text
                    :last-button-text=$global.paginationOptions.last_button_text
                    :prev-text=$global.paginationOptions.prev_text
                    :next-text=$global.paginationOptions.next_text></paginate>
        </dd>
      </dl>
    </div>
    <div class="clear"></div>
  </div>
</template>
<script>
  import api from '@/api/index'
  import config from '@/config/index'
  import utils from '@/utils'
  import Paginate from 'vuejs-paginate'
  import { getCookie } from "@/store/cookies";
  import { mapState } from 'vuex'
  import ModalBox from '@/components/common/modal/index.vue'
  import InfoBox from '@/components/byl/InfoBox/noEdit.vue'
  export default {
    components: { Paginate },
    mounted () {
      this.search(this.filters)
    },
    data () {
      return {
        fuser: {},
        lists: [],
        selected: [], // 选择的列表
        filters: {
          pageNo: 1,
          pageSize: 10,
          delFlag: '0',
          chkFlag: '0',
          search: ''
        },
        opts: {
          checkboxMode: false
        },
        pages: 0,
        cnt: 0,
        tableData: {
          data: []
        }
      }
    },
    computed: {
      ...mapState('auth', ['user'])
    },
    methods: {
      confirmBox (o) {
        var that = this
        this.$modal.show('dialog', {
          title: o.title,
          text: o.text,
          buttons: [
            {
              title: '确认',
              default: true,
              handler: utils.debounce(() => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                  that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                }
              }, 1000)
            },
            {
              title: '取消'
            }
          ]
        })
      },
      updateSelected (val) {
        this.selected = val
      },
      to (path, id) {
        this.$router.push({
          name: path,
          params: {
            id: id
          }
        })
      },
      clickCallback (pageNum)  {
        this.filters.pageNo = pageNum
        this.search(this.filters)
      },
      setUser (item, type) {
        var that = this
        this.confirmBox({
          title: '机构管理员设置',
          text: '确认将' + item.username + '设置为机构管理员吗?',
          yes: function () {
            api.post(config.bylBaseCenterPath, '/user/role/add', {addUserId: item.id, roleType: type}, r => {
              that.$toasted.show('设置成功')
              that.search(that.filters)
              that.$modal.hide('dialog')
            })
          }
        })
      },
      chkUser (item, type) {
        var that = this
        var title
        var text
        var msg
        if (type == '0') {
          title = '用户禁用'
          text = '禁用'
          msg = '用户已禁用'
        } else if (type == '1') {
          title = '用户启用'
          text = '启用'
          msg = '用户已启用'
        }
        this.confirmBox({
          title: title,
          text: '确认' + text + item.name + '吗?',
          yes: function () {
            api.post(config.bylApiPath, '/entUser/saveByAdmin', {userIdList: item.userId, chkFlag: type}, r => {
              that.$toasted.show(msg)
              that.search(that.filters)
              that.$modal.hide('dialog')
            })
          }
        })
      },
      muteUser (item, type) {
        var that = this
        var title
        var text
        var msg
        if (type == '1') {
          title = '用户禁用'
          text = '禁用'
          msg = '用户已禁用'
        } else if (type == '2') {
          title = '用户启用'
          text = '启用'
          msg = '用户已启用'
        } else if (type == '4') {
          title = '用户删除'
          text = '删除'
          msg = '用户已删除'
        }
        this.confirmBox({
          title: title,
          text: '确认' + text + item.name + '吗?',
          yes: function () {
            api.get(config.bylBaseCenterPath, '/user/disable/' + item.userId, {type: type}, r => {
              that.$toasted.show(msg)
              that.search(that.filters)
              that.$modal.hide('dialog')
            })
          }
        })
      },
      multiAudit (arr, options) {
        var that = this
        this.confirmBox({
          title: options.title,
          text: options.text,
          yes: function () {
            api.post(config.bylApiPath, '/entUser/saveByAdmin', {
              userIdList: utils.arr2str(utils.grabVal(arr, 'userId')),
              chkFlag: options.state
            }, r => {
              that.$toasted.show(options.msg)
              that.search(that.filters)
              that.$modal.hide('dialog')
            })
          }
        })
      },
      resetUser (item) {
        var that = this
        this.confirmBox({
          title: '重置密码',
          text: '初始密码为Inesa123# 确认重置密码吗? ',
          yes: function () {
            api.post(config.bylBaseCenterPath, '/user/admin/rePassword', {forgetUserId: item.userId}, r => {
              that.$toasted.show('已重置')
              that.search(that.filters)
              that.$modal.hide('dialog')
            })
          }
        })
      },
      isOrgAdmin (item) {
        if (item && item.roleList) {
          return utils.findElem(item.roleList, 'type', '2') > -1
        }
        return false
      },
      search (filters) {
        if (!filters) { filters = {} }
        if (filters.search) {
          filters.search = filters.search.replace(/\s/g, "")
        }
        var that = this
        api.post(config.bylApiPath, '/entUser/findAccountInfo', filters, function (r) { // 正常
          that.pages = Math.ceil(r.cntData / that.filters.pageSize)
          that.cnt = r.cntData
          if (r.data) {
            that.tableData.data = r.data
          } else {
            that.tableData.data = []
            that.cnt = '0'
          }
        })
      },
      searchByChkFlag (flag) {
        var that = this
        api.post(config.bylApiPath, '/entUser/findAccountInfo', {pageNo: this.filters.pageNo, pageSize: this.filters.pageSize, chkFlag: flag}, function (r) { // 正常
          that.pages = Math.ceil(r.cntData / that.filters.pageSize)
          that.cnt = r.cntData
          if (r.data) {
            that.tableData.data = r.data
          } else {
            that.tableData.data = []
            that.cnt = '0'
          }
        })
      },
      getMemberByUserId (userId) {
        return new Promise(function (resolve, reject) {
          api.post(config.bylApiPath, '/member/by/user', {searchUserId: userId}, r => {
            resolve(r.data)
          })
        })
      },
      showInfo (item) {
        var that = this
        var d = []
        this.getMemberByUserId(item.userId).then((r) => {
          if (r) {
            d = r
          }
          this.$modal.show(ModalBox, {
            opts: {
              title: '用户信息',
              styles: {
                width: '670',
                height: String(0.6181 * window.screen.availHeight)
              },
              offEdit: true,
              currentComponent: {
                name: 'infobox',
                template: InfoBox,
                outputsKey: 'outputs', // 该组件对外输出数据时，定义的key值
                inputs: {
                  data: d
                } // 向组件内传入的数据, 一般用于初始化
              }
            }
          })
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .gj_right .gj_list .el-table__body tbody tr td { padding-left: 0; }
</style>



// WEBPACK FOOTER //
// src/page/byl/org/user/list.vue